import React from "react";
import ReactAdapterProvider, {
  ReactAdapterProviderProps,
} from "./ReactAdapterProvider";

import "../../index.css";

export function withAdapter<PropsType>(Component: React.FC<PropsType>) {
  return React.forwardRef<ReactAdapterProvider<PropsType>>(
    (props: ReactAdapterProviderProps<PropsType>, ref) => {
      return (
        <ReactAdapterProvider<PropsType>
          {...props}
          component={() => (
            <Component {...(props as PropsType)} ref={ref} />
          )}
        />
      );
    }
  );
}
